export const NEW_ADVENTURE_BOOK = 'NEW_ADVENTURE_BOOK';
export const DELETE_ADVENTURE_BOOK = 'DELETE_ADVENTURE_BOOK';
export const START_PAY_ADVENTURE_BOOK = 'START_PAY_ADVENTURE_BOOK';
export const SET_ADVENTURE_BOOKING_ID = 'SET_ADVENTURE_BOOKING_ID';
export const CREATE_ADVENTURE_BOOKING_PAYMENT = 'CREATE_ADVENTURE_BOOKING_PAYMENT';
export const UPDATE_ADVENTURE_BOOKING_PAYMENT = 'UPDATE_ADVENTURE_BOOKING_PAYMENT';
